<template>
    <div >
        <b-form-row>
            <h4 class="section-heading">Purchased Item Information</h4>
        </b-form-row>
        <b-form-row>
            <b-col cols="6">
                <div>
                <!-- Top-left controls -->
                <BaseFormInput
                v-for="item in topLeft"
                :key="item?.id"
                :id="item?.id"
                :label="item.label"
                :labelCols=5
                plaintext
                labelClass="text-muted"
                size="sm"
                readonly
                compact
                :value="item.value"
                marginLeftValue="-12"
                />
                </div>
            </b-col>
            <b-col>
                <div>
                    <!-- Top-right controls -->
                    <BaseFormInput
                    v-for="item in topRight"
                    :key="item?.id"
                    :id="item?.id"
                    :label="item.label"
                    labelAlign="right"
                    :labelCols=5
                    plaintext
                    labelClass="text-muted"
                    size="sm"
                    readonly
                    compact
                    :value="getDisplayValue(item.value)"
                    />
                </div>
                <div class="qty-totals-container">
                    <hr class="m-0 p-0 mr-1"/>
                    <div class="qty-totals d-flex align-items-center justify-content-end">
                        <span class="qty-value">{{ getDisplayValue(productInfo.expectedQty) }}</span>
                        <span class="qty-label, qty-label-expected">Expected qty</span>
                    </div>
                </div>
                <!-- Received/issue qty -->
                <div>
                    <BaseFormInput
                    v-for="item in totalReceivedIssueQty"
                    :key="item?.id"
                    :id="item?.id"
                    :label="item.label"
                    labelAlign="right"
                    :labelCols=5
                    plaintext
                    labelClass="text-muted"
                    size="sm"
                    readonly
                    compact
                    :value="getDisplayValue(item.value)"
                    />
                </div>
                <div class="qty-totals-container">
                    <hr class="m-0 p-0 mr-1"/>
                    <div class="qty-totals">
                        <span class="qty-value">{{ getDisplayValue(productInfo.pendingQty) }}</span>
                        <span class="qty-label, qty-label-pending">Pending qty</span>
                    </div>
                </div>
            </b-col>
        </b-form-row>
    </div>
</template>

<script>
export default {
    props: {
        productInfo: {type: Object, required: true}
    },
    data() {
        return {
            item: {}
        };
    },
    async mounted() {
    },
    computed: {
        topLeft() {
            return [
                { id: 'id', label: 'Purchased item id:', value: this.productInfo?.id },
                { id: 'orderNumber', label: 'Order number:', value: this.productInfo?.orderNumber},
                { id: 'trackingNubmer', label: 'Source tracking #:', value: this.productInfo?.trackingNumber },
                { id: 'asin', label: 'Asin:', value: this.productInfo?.productId },
                { id: 'sku', label: 'SKU:', value: this.productInfo?.sku },
                { id: 'fnsku', label: 'FnSku:', value: this.productInfo?.fnsku },
                { id: 'upc', label: 'UPC:', value: this.productInfo?.upc },
            ]
        },
        topRight() {
            return [
                { id: 'purchasedQty', label: 'Purchased qty:', value: this.productInfo?.purchasedQty},
                { id: 'extraQty', label: 'Extra qty:', value: this.productInfo?.extraQty},
                { id: 'replacementQty', label: 'Replacement qty:', value: this.productInfo?.replacementQty},
                { id: 'canceledQty', label: 'Canceled qty:', value: this.productInfo?.canceledQty},
            ]
        },
        totalReceivedIssueQty() {
            return [
                { id: 'pastReceivedQty', label: 'Total received qty:', value: this.productInfo?.pastReceivedQty},
                { id: 'totalIssueQty', label: 'Total issue qty:', value: this.productInfo?.totalIssueQty},
                { id: 'totalIssueReceivableQty', label: 'Issue receivable qty:', value: this.productInfo?.receivableIssueQty},
            ]
        },
        expectedQty() {
            return Number(this.productInfo?.purchasedQty || 0) + Number(this.productInfo?.extraQty || 0) + Number(this.productInfo?.replacementQty || 0) - Number(this.productInfo?.canceledQty || 0);
        },
        pendingQty() {
            return Number(this.expectedQty || 0) - Number(this.productInfo?.pastReceivedQty || 0) - Number(this.productInfo?.totalIssueQty || 0) + Number(this.productInfo?.receivableIssueQty || 0);
        },
        noHistory() {
            return this.productInfo.logs?.length === 0;
        }
    },
    methods: {
        convertNumberToBoolean(value) {
            return value === 1 ? "true": "false"
        },
        getDisplayValue(value) {
            return this.productInfo?.purchasedItemRecordId ? value : '';
        }
    },
};
</script>

<style scoped>
.custom-modal .modal-dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Full viewport height */
}

.custom-modal .modal-content {
  margin: auto; /* Center content horizontally */
}
.section-heading {
    color: #555;
    font-size: .9em;
    font-weight: 600;
    margin-left: 5px;
}

.qty-totals-container {
    position: relative;
} 

.qty-totals {
    position: absolute;
    bottom: 0;
    right: 0;
}

.qty-value {
    font-weight: 600;
}

.qty-label, .qty-label-pending, .qty-label-expected {
    margin-left: 15px;
    font-size: .9rem;
    color: #555;
}

.qty-label-expected {
    margin-right: 35px;
}

.qty-label-pending {
    margin-right: 40px;
    margin-left: 15px;
}

</style>
